import { GetterTree } from 'vuex';
import { EvaluationsState } from '@/store/evaluations/types';
import { RootState } from '@/store/types';
import _ from 'lodash';

const getters : GetterTree<EvaluationsState, RootState> = {
  /**
   * チューターIDを使って評価詳細を取得
   * @param {string} tutorId チューターID
   */
  getEvaluationByTutorId: (state: EvaluationsState) => (tutorId: string) => {
    return _.find(state.evaluations, { tutorId })
  },
};

export default getters;
